import axios, {AxiosRequestConfig, AxiosResponse, AxiosError} from 'axios';

// 根据环境配置基础URL
const getBaseUrl = (): string => {
    if (location.href.includes('localhost') || location.href.includes('inte')) {
        return 'https://inte-www.chanjetvip.com/';
    } else {
        return 'https://www.chanjetvip.com/';
    }
};

// 创建 axios 实例
const api = axios.create({
    baseURL: getBaseUrl(),
    timeout: 10000, // 请求超时时间
});

// 请求拦截器
api.interceptors.request.use(
    (config: AxiosRequestConfig) => {
        // 可以在这里添加请求头、认证信息等
        console.log('请求发送:', config);
        return config;
    },
    (error: AxiosError) => {
        // 请求错误处理
        console.error('请求错误:', error);
        return Promise.reject(error);
    }
);

// 响应拦截器
api.interceptors.response.use(
    (response: AxiosResponse) => {
        // 成功响应处理
        const {data} = response;

        // 假设后端返回的数据结构为 { code: number, data: any, message?: string }
        if (data.code === 0) {
            // 请求成功，返回数据
            return Promise.resolve(data);
        } else {
            // 请求失败，返回错误
            console.error('接口请求失败:', data);
            // return Promise.reject(new Error(data.message || '接口请求失败'));
            return Promise.resolve(data);
        }

        // 如果返回的数据结构不符合预期，直接返回响应
        return Promise.resolve(response);
    },
    (error: AxiosError) => {
        // 响应错误处理
        console.error('响应错误:', error);

        // 根据错误类型进行处理
        if (error.response) {
            // 服务器返回了错误状态码
            const {status, data} = error.response;
            console.error(`HTTP错误 ${status}:`, data);
        } else if (error.request) {
            // 请求已发出但没有收到响应
            console.error('请求无响应:', error.request);
        } else {
            // 其他错误
            console.error('请求配置错误:', error.message);
        }

        // 返回错误信息
        return Promise.reject(error);
    }
);

export default api;
